export enum MensagemAlteracaoCd {
  MENSAGEM_PADRAO = 'A confirmação desta alteração pode acarretar em alterações nos preços dos produtos e a disponibilidade dos mesmos, deseja prosseguir?',
  MENSAGEM_LOGIN = 'Compra iniciada em outra loja. A confirmação desta alteração pode acarretar em alterações nos preços dos produtos e a disponibilidade dos mesmos, deseja prosseguir?',
}
